import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "analytics/Interactions";
import { unregister } from "./registerServiceWorker";
import CssBaseline from "@material-ui/core/CssBaseline";

ReactDOM.render(
  <React.Fragment>
    <CssBaseline />
    <App />
  </React.Fragment>,
  document.getElementById("root")
);

unregister();
